// extracted by mini-css-extract-plugin
module.exports = {"component":"_2cx8o","loader":"MtCav"};